import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Feature } from '../../map-data-services/feature/feature';
import { Task } from '../task/task';
import { TasksStore } from './tasks-store.service';

@Injectable({
    providedIn: 'root'
})
export class TasksStreamsService {
    // --------------
    // Map Workspace tasks streams

    disableMapviewerStream: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    visibleTasksStream = new BehaviorSubject<Task[]>([]);
    selectedTasksStream = new BehaviorSubject<Task[]>([]);
    addFeaturesToTaskStream = new BehaviorSubject<Feature[]>([]);
    pendingLoadingTaskStream = new BehaviorSubject<{ task: Task; loading: boolean }>(null);
    deferVisibleTasksStream = new BehaviorSubject<Task[]>([]);
    deferHideTasksStream = new BehaviorSubject<Task[]>([]);
    newTaskFromSelectionStream = new BehaviorSubject<boolean>(false);
    mapWorkspaceTasksStream: BehaviorSubject<Task[]>;

    constructor(private tasksStore: TasksStore) {
        // ! GIM 20/5/2019 - This line used to have a shareReplay on it, but the underlying
        // ! observable is a BehaviourSubject so not applicable
        this.mapWorkspaceTasksStream = tasksStore.mapWorkspaceTasksStream;
    }

    public setVisibleTasks(tasks: Task[]): void {
        this.visibleTasksStream.next(tasks);
    }

    public setSelectedTasks(tasks: Task[]): void {
        this.selectedTasksStream.next(tasks);
    }

    public setTaskAsLoading(task: Task): void {
        this.pendingLoadingTaskStream.next({ task: task, loading: true });
    }

    public setTaskAsLoaded(task: Task): void {
        this.pendingLoadingTaskStream.next({ task: task, loading: false });
    }
}
